import { useMemo } from 'react'

import { useModals, useNumericParams, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditInvoiceModal from '@modals/CreateOrEditInvoiceModal'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateOrEditInvoiceModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditInvoiceModal: {
      closeModal: () => setState({ showCreateOrEditInvoiceModal: false }),
      updateInvoice: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const Details = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateOrEditInvoiceModal,
  } = state

  const { invoiceId } = useNumericParams()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      updateInvoice: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent invoiceId={invoiceId} />

        <CreateOrEditInvoiceModal
          // @ts-expect-error TS2741
          callbacks={callbacks('CreateOrEditInvoiceModal', setState)}
          showModal={showCreateOrEditInvoiceModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Details
